import { NavLink } from "react-router-dom";
import {
  Building2,
  CheckSquare,
  IdCard,
  LayoutDashboard,
  Package,
  TestTubes,
  Users,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useI18n } from "@/i18n";
import type { TranslationKey } from "@/i18n/translations";

const items: { to: string; label: TranslationKey; icon: typeof Building2 }[] = [
  { to: "/", label: "navOverview", icon: LayoutDashboard },
  { to: "/companies", label: "navCompanies", icon: Building2 },
  { to: "/products", label: "navProducts", icon: Package },
  { to: "/samples", label: "navSamples", icon: TestTubes },
  { to: "/tasks", label: "navTasks", icon: CheckSquare },
  { to: "/members", label: "navMembers", icon: Users },
  { to: "/card", label: "navCard", icon: IdCard },
];

export function Sidebar() {
  const { t } = useI18n();

  return (
    <nav className="flex gap-1 overflow-x-auto border-b border-border p-2 md:h-full md:w-56 md:flex-col md:overflow-visible md:border-b-0 md:border-r md:p-3">
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          // `end` only on the root, or every route would light it up.
          end={to === "/"}
          className={({ isActive }) =>
            cn(
              "flex shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
              isActive
                ? "bg-primary/12 text-primary"
                : "text-muted-foreground hover:bg-muted hover:text-foreground"
            )
          }
        >
          <Icon className="size-4" />
          {t(label)}
        </NavLink>
      ))}
    </nav>
  );
}
